__turbopack_export_value__({
  "body-logo-18": "PromoSlider-module-scss-module__MS8AIq__body-logo-18",
  "body-text-12": "PromoSlider-module-scss-module__MS8AIq__body-text-12",
  "body-text-14": "PromoSlider-module-scss-module__MS8AIq__body-text-14",
  "body-text-16": "PromoSlider-module-scss-module__MS8AIq__body-text-16",
  "body-text-18": "PromoSlider-module-scss-module__MS8AIq__body-text-18",
  "body-text-20": "PromoSlider-module-scss-module__MS8AIq__body-text-20",
  "body-text-24": "PromoSlider-module-scss-module__MS8AIq__body-text-24",
  "body-text-24-2": "PromoSlider-module-scss-module__MS8AIq__body-text-24-2",
  "body-text-heading-2": "PromoSlider-module-scss-module__MS8AIq__body-text-heading-2",
  "body-text-heading-3": "PromoSlider-module-scss-module__MS8AIq__body-text-heading-3",
  "body-text-medium-14": "PromoSlider-module-scss-module__MS8AIq__body-text-medium-14",
  "body-text-medium-16": "PromoSlider-module-scss-module__MS8AIq__body-text-medium-16",
  "body-text-medium-18": "PromoSlider-module-scss-module__MS8AIq__body-text-medium-18",
  "body-text-medium2-18": "PromoSlider-module-scss-module__MS8AIq__body-text-medium2-18",
  "body-text2-14": "PromoSlider-module-scss-module__MS8AIq__body-text2-14",
  "body-text2-16": "PromoSlider-module-scss-module__MS8AIq__body-text2-16",
  "button-primary-text": "PromoSlider-module-scss-module__MS8AIq__button-primary-text",
  "button-text": "PromoSlider-module-scss-module__MS8AIq__button-text",
  "button2-text": "PromoSlider-module-scss-module__MS8AIq__button2-text",
  "card-shadow": "PromoSlider-module-scss-module__MS8AIq__card-shadow",
  "effect-menu": "PromoSlider-module-scss-module__MS8AIq__effect-menu",
  "header-1": "PromoSlider-module-scss-module__MS8AIq__header-1",
  "main-container": "PromoSlider-module-scss-module__MS8AIq__main-container",
  "main-footer-container": "PromoSlider-module-scss-module__MS8AIq__main-footer-container",
  "main-header-container": "PromoSlider-module-scss-module__MS8AIq__main-header-container",
  "promoSection__head": "PromoSlider-module-scss-module__MS8AIq__promoSection__head",
  "promoSection__navButtons": "PromoSlider-module-scss-module__MS8AIq__promoSection__navButtons",
  "promoSection__showAllButton": "PromoSlider-module-scss-module__MS8AIq__promoSection__showAllButton",
  "promoSection__slide": "PromoSlider-module-scss-module__MS8AIq__promoSection__slide",
  "promoSection__title": "PromoSlider-module-scss-module__MS8AIq__promoSection__title",
  "sliderWrapper": "PromoSlider-module-scss-module__MS8AIq__sliderWrapper",
  "txt-12-bold": "PromoSlider-module-scss-module__MS8AIq__txt-12-bold",
  "txt-14-bold": "PromoSlider-module-scss-module__MS8AIq__txt-14-bold",
  "txt-14-bold-caps": "PromoSlider-module-scss-module__MS8AIq__txt-14-bold-caps",
  "txt-14-med": "PromoSlider-module-scss-module__MS8AIq__txt-14-med",
  "txt-16-bold": "PromoSlider-module-scss-module__MS8AIq__txt-16-bold",
  "txt-16-med": "PromoSlider-module-scss-module__MS8AIq__txt-16-med",
  "txt-18-bold": "PromoSlider-module-scss-module__MS8AIq__txt-18-bold",
  "txt-18-medium": "PromoSlider-module-scss-module__MS8AIq__txt-18-medium",
  "txt-18-medium-24": "PromoSlider-module-scss-module__MS8AIq__txt-18-medium-24",
  "txt-24-semi": "PromoSlider-module-scss-module__MS8AIq__txt-24-semi",
});
